import { render, staticRenderFns } from "./loginuser.vue?vue&type=template&id=5ba64e84&scoped=true&"
import script from "./loginuser.vue?vue&type=script&lang=js&"
export * from "./loginuser.vue?vue&type=script&lang=js&"
import style0 from "./loginuser.vue?vue&type=style&index=0&id=5ba64e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba64e84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
